export default __webpack_public_path__ + "static/media/Map_pin.d0b9a16e.svg";